import VideoBlok from './video_blok'
import VideoInline from './video_inline'

export default {
  video_blok: VideoBlok,
  video_inline: VideoInline,
}
